function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _awaitAsyncGenerator(e) { return new _OverloadYield(e, 0); }
function _wrapAsyncGenerator(e) { return function () { return new AsyncGenerator(e.apply(this, arguments)); }; }
function AsyncGenerator(e) { var r, t; function resume(r, t) { try { var n = e[r](t), o = n.value, u = o instanceof _OverloadYield; Promise.resolve(u ? o.v : o).then(function (t) { if (u) { var i = "return" === r ? "return" : "next"; if (!o.k || t.done) return resume(i, t); t = e[i](t).value; } settle(n.done ? "return" : "normal", t); }, function (e) { resume("throw", e); }); } catch (e) { settle("throw", e); } } function settle(e, n) { switch (e) { case "return": r.resolve({ value: n, done: !0 }); break; case "throw": r.reject(n); break; default: r.resolve({ value: n, done: !1 }); } (r = r.next) ? resume(r.key, r.arg) : t = null; } this._invoke = function (e, n) { return new Promise(function (o, u) { var i = { key: e, arg: n, resolve: o, reject: u, next: null }; t ? t = t.next = i : (r = t = i, resume(e, n)); }); }, "function" != typeof e.return && (this.return = void 0); }
AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, AsyncGenerator.prototype.next = function (e) { return this._invoke("next", e); }, AsyncGenerator.prototype.throw = function (e) { return this._invoke("throw", e); }, AsyncGenerator.prototype.return = function (e) { return this._invoke("return", e); };
function _OverloadYield(e, d) { this.v = e, this.k = d; }
import { importJWK } from '../key/import.js';
import { JWKSInvalid, JOSENotSupported, JWKSNoMatchingKey, JWKSMultipleMatchingKeys } from '../util/errors.js';
import isObject from '../lib/is_object.js';
function getKtyFromAlg(alg) {
  switch (typeof alg === 'string' && alg.slice(0, 2)) {
    case 'RS':
    case 'PS':
      return 'RSA';
    case 'ES':
      return 'EC';
    case 'Ed':
      return 'OKP';
    default:
      throw new JOSENotSupported('Unsupported "alg" value for a JSON Web Key Set');
  }
}
function isJWKSLike(jwks) {
  return jwks && _typeof(jwks) === 'object' && Array.isArray(jwks.keys) && jwks.keys.every(isJWKLike);
}
function isJWKLike(key) {
  return isObject(key);
}
function clone(obj) {
  if (typeof structuredClone === 'function') {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}
var LocalJWKSet = /*#__PURE__*/function () {
  function LocalJWKSet(jwks) {
    _classCallCheck(this, LocalJWKSet);
    this._cached = new WeakMap();
    if (!isJWKSLike(jwks)) {
      throw new JWKSInvalid('JSON Web Key Set malformed');
    }
    this._jwks = clone(jwks);
  }
  return _createClass(LocalJWKSet, [{
    key: "getKey",
    value: function () {
      var _getKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(protectedHeader, token) {
        var _protectedHeader$toke, alg, kid, kty, candidates, jwk, length, error, _cached;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _protectedHeader$toke = _objectSpread(_objectSpread({}, protectedHeader), token === null || token === void 0 ? void 0 : token.header), alg = _protectedHeader$toke.alg, kid = _protectedHeader$toke.kid;
              kty = getKtyFromAlg(alg);
              candidates = this._jwks.keys.filter(function (jwk) {
                var candidate = kty === jwk.kty;
                if (candidate && typeof kid === 'string') {
                  candidate = kid === jwk.kid;
                }
                if (candidate && typeof jwk.alg === 'string') {
                  candidate = alg === jwk.alg;
                }
                if (candidate && typeof jwk.use === 'string') {
                  candidate = jwk.use === 'sig';
                }
                if (candidate && Array.isArray(jwk.key_ops)) {
                  candidate = jwk.key_ops.includes('verify');
                }
                if (candidate) {
                  switch (alg) {
                    case 'ES256':
                      candidate = jwk.crv === 'P-256';
                      break;
                    case 'ES256K':
                      candidate = jwk.crv === 'secp256k1';
                      break;
                    case 'ES384':
                      candidate = jwk.crv === 'P-384';
                      break;
                    case 'ES512':
                      candidate = jwk.crv === 'P-521';
                      break;
                    case 'Ed25519':
                      candidate = jwk.crv === 'Ed25519';
                      break;
                    case 'EdDSA':
                      candidate = jwk.crv === 'Ed25519' || jwk.crv === 'Ed448';
                      break;
                  }
                }
                return candidate;
              });
              jwk = candidates[0], length = candidates.length;
              if (!(length === 0)) {
                _context2.n = 1;
                break;
              }
              throw new JWKSNoMatchingKey();
            case 1:
              if (!(length !== 1)) {
                _context2.n = 2;
                break;
              }
              error = new JWKSMultipleMatchingKeys();
              _cached = this._cached;
              error[Symbol.asyncIterator] = /*#__PURE__*/_wrapAsyncGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var _iterator, _step, _jwk, _t, _t2;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _iterator = _createForOfIteratorHelper(candidates);
                      _context.p = 1;
                      _iterator.s();
                    case 2:
                      if ((_step = _iterator.n()).done) {
                        _context.n = 8;
                        break;
                      }
                      _jwk = _step.value;
                      _context.p = 3;
                      _context.n = 4;
                      return _awaitAsyncGenerator(importWithAlgCache(_cached, _jwk, alg));
                    case 4:
                      _context.n = 5;
                      return _context.v;
                    case 5:
                      _context.n = 7;
                      break;
                    case 6:
                      _context.p = 6;
                      _t = _context.v;
                    case 7:
                      _context.n = 2;
                      break;
                    case 8:
                      _context.n = 10;
                      break;
                    case 9:
                      _context.p = 9;
                      _t2 = _context.v;
                      _iterator.e(_t2);
                    case 10:
                      _context.p = 10;
                      _iterator.f();
                      return _context.f(10);
                    case 11:
                      return _context.a(2);
                  }
                }, _callee, null, [[3, 6], [1, 9, 10, 11]]);
              }));
              throw error;
            case 2:
              return _context2.a(2, importWithAlgCache(this._cached, jwk, alg));
          }
        }, _callee2, this);
      }));
      function getKey(_x, _x2) {
        return _getKey.apply(this, arguments);
      }
      return getKey;
    }()
  }]);
}();
function importWithAlgCache(_x3, _x4, _x5) {
  return _importWithAlgCache.apply(this, arguments);
}
function _importWithAlgCache() {
  _importWithAlgCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(cache, jwk, alg) {
    var cached, key;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
          if (!(cached[alg] === undefined)) {
            _context4.n = 3;
            break;
          }
          _context4.n = 1;
          return importJWK(_objectSpread(_objectSpread({}, jwk), {}, {
            ext: true
          }), alg);
        case 1:
          key = _context4.v;
          if (!(key instanceof Uint8Array || key.type !== 'public')) {
            _context4.n = 2;
            break;
          }
          throw new JWKSInvalid('JSON Web Key Set members must be public keys');
        case 2:
          cached[alg] = key;
        case 3:
          return _context4.a(2, cached[alg]);
      }
    }, _callee4);
  }));
  return _importWithAlgCache.apply(this, arguments);
}
export function createLocalJWKSet(jwks) {
  var set = new LocalJWKSet(jwks);
  var localJWKSet = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(protectedHeader, token) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            return _context3.a(2, set.getKey(protectedHeader, token));
        }
      }, _callee3);
    }));
    return function localJWKSet(_x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();
  Object.defineProperties(localJWKSet, {
    jwks: {
      value: function value() {
        return clone(set._jwks);
      },
      enumerable: true,
      configurable: false,
      writable: false
    }
  });
  return localJWKSet;
}